// common/js/sidebarAnimation.js
import $ from 'jquery';

export default class SidebarJs {
    toggle() {
        // === Main left sidebar toggle (hamburger + round pill) ===
        $("#sidebarToggle, #sidebarToggleTop, .toggleRightBar")
            .off("click.sidebar")
            .on("click.sidebar", function (e) {
                e.preventDefault();

                $("body").toggleClass("sidebar-toggled");
                $(".sidebar").toggleClass("toggled");

                const isCollapsed = $(".sidebar").hasClass("toggled");

                if (isCollapsed) {
                    $(".sidebar .collapse").collapse("hide");
                    $(".aside-menu-right").show();
                    $("#showRightBar").hide();
                } else {
                    $(".aside-menu-right").hide();
                    $("#showRightBar").show();
                }

                // keep ARIA in sync (optional)
                $("#sidebarToggle, #sidebarToggleTop")
                    .toggleClass("is-collapsed", isCollapsed)
                    .attr("aria-expanded", String(!isCollapsed));
            });

        // === CLICKING A PARENT WHILE COLLAPSED: expand sidebar, then open that submenu ===
        $(".sidebar .nav-item > a[data-toggle='collapse']")
            .off("click.sidebar-expand")
            .on("click.sidebar-expand", function (e) {
                const $sidebar = $(".sidebar");
                const isCollapsed = $sidebar.hasClass("toggled");
                if (!isCollapsed) return;                // already expanded → let Bootstrap handle

                e.preventDefault();
                const target = $(this).attr("data-target"); // e.g. "#collapse123"

                // 1) Expand the sidebar
                $("body").removeClass("sidebar-toggled");
                $sidebar.removeClass("toggled");
                $("#sidebarToggle, #sidebarToggleTop")
                    .removeClass("is-collapsed")
                    .attr("aria-expanded", "true");

                // 2) After layout settles, open the clicked submenu (and close others)
                setTimeout(() => {
                    $(".sidebar .collapse").not(target).collapse("hide");
                    $(target).collapse("show");
                }, 10);
            });

        // === Right sidebar (unchanged) ===
        $("#sidebarRightToggle")
            .off("click.sidebar")
            .on("click.sidebar", function (e) {
                e.preventDefault();
                $("body").toggleClass("aside-menu-lg-show");
                $(".aside-menu").toggleClass("toggled");
                if ($(".aside-menu").hasClass("toggled")) {
                    $(".aside-menu .collapse").collapse("hide");
                }
            });

        $(".questionaireRightBar")
            .off("click.sidebar")
            .on("click.sidebar", function (e) {
                e.preventDefault();
                $(".aside-menu-right").toggleClass("collapsed");
                $(".arrowBtn").toggle();
            });

        // Close accordions on small screens
        $(window)
            .off("resize.sidebar")
            .on("resize.sidebar", function () {
                if ($(window).width() < 768) {
                    $(".sidebar .collapse").collapse("hide");
                }
            });

        // Prevent page scroll when hovering fixed sidebar
        $("body.fixed-nav .sidebar")
            .off("mousewheel.sidebar DOMMouseScroll.sidebar wheel.sidebar")
            .on(
                "mousewheel.sidebar DOMMouseScroll.sidebar wheel.sidebar",
                function (e) {
                    if ($(window).width() > 768) {
                        const e0 = e.originalEvent;
                        const delta = e0.wheelDelta || -e0.detail;
                        this.scrollTop += (delta < 0 ? 1 : -1) * 30;
                        e.preventDefault();
                    }
                }
            );

        // Keep dropdowns clickable
        $(".scoring-drop.btn-group .dropdown-menu")
            .off("click.sidebar")
            .on("click.sidebar", function (e) {
                e.stopPropagation();
            });
    }
}
